// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__8jkd7","label":"Category_label__lkd-9","content":"Category_content__1tnpY","header":"Category_header__e0A5R","location":"Category_location__bxfEs"};